import httpClient from '@/api/index';

export default {
    getSlider: function () {
        return httpClient().get('/json/home_slider');
    },
    getPartnership: function () {
        return httpClient().get('/json/home_partnership');
    },
    getWahana: function () {
        return httpClient().get('/json/home_wahana');
    },
    getHargaTiket: function () {
        return httpClient().get('/json/home_harga_tiket');
    },
    getPaketGroup: function () {
        return httpClient().get('/json/home_paket_group');
    },
    postBeliTiketReguler: function (data) {
        return httpClient().post('/json/beli_tiket_reguler',data);
    },
    postBayarReservasi: function (uuid) {
        return httpClient().post('/json/bayar_reservasi/' + uuid);
    },
    postBeliTiketPaket: function (data) {
        return httpClient().post('/json/beli_tiket_paket',data);
    },
    postNewsletter: function (data) {
        return httpClient().post('/json/home_newsletter',data);
    },
}
